import React, { FunctionComponent } from 'react';
import * as graphCMS from '../../../domain/graphcms';
import { getAdvByTypeSync } from '../../../services/advs/advs';
import AdvFluid from '../adv-fluid/AdvFluid';

export interface AdvFluidAdapterProps {
  advFluidType?: graphCMS.AdvFluidType,
  variant?: graphCMS.AdvFluidVariant,
  dataTrackingPrefix?: string,
  onClick?: VoidFunction,
}

const AdvFluidAdapter: FunctionComponent<AdvFluidAdapterProps> = ({
  advFluidType = graphCMS.AdvFluidType.SELL_PROPERTY,
  variant = graphCMS.AdvFluidVariant.VARIANT_1,
  dataTrackingPrefix,
  onClick,
}) => {
  const advData = getAdvByTypeSync(advFluidType);

  return (
    <AdvFluid
      {...advData}
      dataTracking={`${dataTrackingPrefix ? `${dataTrackingPrefix}:` : ''}AdvFluid:${advFluidType}:${variant}`}
      variant={variant}
      onClick={onClick}
    />
  );
};

export default AdvFluidAdapter;
